import { BoxLayout } from '../boxes/BoxLayout';
import { DeviceTunes } from '../deviceTunes/DeviceTunes';
import { ObjectBoxes } from '../boxes/objectBoxes/ObjectBoxes';
import { MeasurementBoxes } from '../boxes/measurementBoxes/MeasurementBoxes';
import { isObjectBox, isMeasurementBox, isTuneControl } from '@/components/contentContainers/entityValidators.ts';

import type { PlanningEntity } from './PlanningContainer';
import type { FC } from 'react';
import type { IPlanningEntityProps } from '@/components/common/interfaces.ts';

export const EntityBox: FC<IPlanningEntityProps<PlanningEntity>> = ({ entity }) => {
  return (
    <BoxLayout key={'entity-box- ' + entity.order} title={!isTuneControl(entity) ? entity.label : ''}>
      {isTuneControl(entity) && <DeviceTunes entity={entity} />}
      {isObjectBox(entity) && <ObjectBoxes entity={entity}  />}
      {isMeasurementBox(entity) && <MeasurementBoxes entity={entity}  />}
    </BoxLayout>
  );
};
